import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { withStorageSync } from '@angular-architects/ngrx-toolkit';
import { withEntities } from '@ngrx/signals/entities';
import { SyncStoreStateType } from './model/sync-store-state-type';
import { SyncStoreSaveData } from './update-data/sync-store-save-data';
import { SyncStoreUpdateAnimalWeighing } from './update-data/sync-store-update-animal-weighing';
import { SyncStoreUpdateBatchWeighing } from './update-data/sync-store-update-batch-weighing';
import { SyncStoreUpdateRemoval } from './update-data/sync-store-update-removal';
import { persistAnimalWeighings } from '../../functions/sync-store/sync-store-update-animal-weighing.function';
import { persistBatchWeighings } from '../../functions/sync-store/sync-store-update-batch-weighing.function';

export const initialState: SyncStoreStateType = {
  animalWeighings: [],
  batchWeighings: [],
  removals: [],
};

export const SyncStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withStorageSync('syncStore-001'),
  withEntities(),
  withMethods((store) => ({
    storePersistAnimalWeighings(newdata: SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>): void {
      patchState(store, persistAnimalWeighings(newdata, store.animalWeighings));
    },
    storePersistBatchWeighings(newdata: SyncStoreSaveData<SyncStoreUpdateBatchWeighing>): void {
      patchState(store, persistBatchWeighings(newdata, store.batchWeighings));
    },
    storePersistRemovals(newdata: SyncStoreSaveData<SyncStoreUpdateRemoval>): void {
      patchState(store, {
        removals: [...store.removals(), newdata],
      });
    },
    getAnimalWeighings(): SyncStoreSaveData<SyncStoreUpdateAnimalWeighing>[] {
      return store.animalWeighings();
    },
    getBatchWeighings(): SyncStoreSaveData<SyncStoreUpdateBatchWeighing>[] {
      return store.batchWeighings();
    },
    getRemovals(): SyncStoreSaveData<SyncStoreUpdateRemoval>[] {
      return store.removals();
    },
    clear(): void {
      patchState(store, {
        animalWeighings: [],
        batchWeighings: [],
        removals: [],
      });
    }
  }))
);
